import axios from '@/services/api'

/**
 * @param {File} image
 *
 * @returns {Promise<Object>}
 */
export const addImage = (image) => {
	const url = 'api/files'
	return axios.post(url, image)
}
